declare let BigNumber: any;

import { DealtAmtAdapter } from "./DealtAmtAdapter";

import { ColumnDefinition } from "../../model/ColumnDefinition";

import { ICcyLookupService } from "../../lookup/model/ICcyLookupService";

import { RenderFillPercentCell } from "../common/RenderFillPercentCell";

// This is unused - use executedQty directly on OrderData
export class ExecutedDealtAmtAdapter extends DealtAmtAdapter {
  constructor(ccyPairLookup: ICcyLookupService) {
    super(ccyPairLookup);
  }

  adapt(column: ColumnDefinition, row: any, ...modelObjects: Array<any>): void {
    super.adapt(column, row, ...modelObjects);

    row[column.data] = RenderFillPercentCell.wrap(column.data, row);
  }
}
